<template>
  <div class="yj-button-group">
    <slot></slot>
  </div>
</template>
<script>
  export default {
    name: 'YjButtonGroup'
  };
</script>



// WEBPACK FOOTER //
// src/components/button/src/button-group.vue